<template lang="html">
    <!-- <div class="flex-col diagnosticDetail-container"> -->
    <div class="">
        <div class="breadCrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>{{$t('message.diagnostic')}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="diagnostic-table verifone-panel diag-panel">
            <div class="flex-col appManagement-table-main">
                <div class="flex-row diagnostic-title">
                    <div class="item-title"><span class="title-tip">{{$t('message.sn')}}&nbsp;&nbsp;&nbsp;</span>{{sn}}</div>
                    <div class="item-title"><span class="title-tip">{{$t('message.date')}}&nbsp;&nbsp;&nbsp;</span>{{diagnostic.localReportTime}}</div>
                </div>
                <div class="table-title">{{$t('message.currentInstall')}}</div>
                <template>
                    <div class="self-table-contianer">
                        <table width="100%" class="self-table"  border="1" bordercolor="#dadada" style="border-collapse:collapse;">
                            <thead>
                                <tr class="self-tr">
                                    <th>{{$t('message.appName')}}</th>
                                    <th>{{$t('message.version')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="appItem in installApps">
                                    <td>{{appItem.appName}}</td>
                                    <td>{{appItem.version}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-title">{{$t('message.diagnosticData')}}</div>
                    <div class="self-table-contianer">
                        <table width="100%" border="1" bordercolor="#dadada" style="border-collapse:collapse;" class="self-table">
                            <thead>
                                <tr class="self-tr">
                                    <th>{{$t('message.paramName')}}</th>
                                    <th>{{$t('message.value')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{$t('message.imei')}}</td>
                                    <td>{{diagnostic.imei}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.meid')}}</td>
                                    <td>{{diagnostic.meid}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.memoryTotal')}}</td>
                                    <td>{{diagnostic.memoryTotal}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.memoryAvailable')}}</td>
                                    <td>{{diagnostic.memoryAvailable}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.flashTotal')}}</td>
                                    <td>{{diagnostic.flashTotal}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.flashAvailable')}}</td>
                                    <td>{{diagnostic.flashAvailable}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.mobileDataFlow')}}</td>
                                    <td>{{diagnostic.mobileDataFlow}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.turnOnOffTimes')}}</td>
                                    <td>{{diagnostic.turnOnOffTimes}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.turnOnTime')}}</td>
                                    <td>{{diagnostic.turnOnTime}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.turnOnTimeSummary')}}</td>
                                    <td>{{diagnostic.turnOnTimeSummary}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.printerLength')}}</td>
                                    <td>{{diagnostic.printerLength}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.cardTimes')}}</td>
                                    <td>{{diagnostic.cardTimes}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.icCardTimes')}}</td>
                                    <td>{{diagnostic.icCardTimes}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.untouchCardTimes')}}</td>
                                    <td>{{diagnostic.untouchCardTimes}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.frontCameraOpenTimes')}}</td>
                                    <td>{{diagnostic.frontCameraOpenTimes}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.backCameraOpenTimes')}}</td>
                                    <td>{{diagnostic.backCameraOpenTimes}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.batteryTemperature')}}</td>
                                    <td>{{diagnostic.batteryTemperature}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.battery')}}</td>
                                    <td>{{diagnostic.battery}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('message.batteryChargeTimes')}}</td>
                                    <td>{{diagnostic.batteryChargeTimes}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
            <div class="submit-container">
                <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.back')}}</el-button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            installApps:[],
            diagnostic :{},
            sn:''
        }
    },
    mounted() {
        this.loadDiagnosticDetail();
    },
    methods: {
        callBack() {
            this.$router.replace('/diagnosticList');
        },
        loadDiagnosticDetail(){
            let id = this.$route.query.id,
            that = this,
            obj = {
                id:id
            };

            this.$axios({
                method: 'post',
                url: '/marketplace/diagnostic/detail',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.installApps = response.data.installApps;
                    that.diagnostic= response.data.diagnostic;
                    that.sn=response.data.sn;
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }
}
</script>

<style lang="css" scoped="scope">
.diagnosticDetail-container {
    /*background-color: #E0EAF4;*/
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    /*justify-content: center;*/
    align-items: center;
    width: 100%;
}
.diagnostic-table {
    background: #fff;
}
.self-table {
    max-height: 330px;
}
.self-table th,.self-table td {
    padding: 8px 10px;
}
.self-tr {
    background: #f2f2f2;
}
.table-title {
    padding: 15px 0;
}
.self-table-contianer {
    max-height: 30vh;
    overflow:auto;
}
.diagnostic-title {
    justify-content: space-between;
    border-bottom:1px solid #819bd3;
    padding: 10px 0;
}
.title-tip {
    font-weight: bold;
}
.diag-panel {
    margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/DiagnosticDetial.vue